module.exports = __webpack_public_path__ + "static/avaliable-logo-bar-a497b32b0921fcae8009cedb0e0d2940.png";